import { Component } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import DailyTotalTable from './DailyTotalTable'
import { LogFilter } from '../../../../components/generic'

class DailyTotalChart extends Component {
  constructor(props) {
    super(props)
    this.state = this.getDefaultState()
  }

  getDefaultState() {
    return {
      to: dayjs(),
      from: dayjs().subtract(28, 'days').startOf('day'),
    }
  }

  setDates = ({ startDate, endDate }) => {
    if (startDate && endDate) {
      this.setState({
        to: dayjs(endDate).endOf('day'),
        from: dayjs(startDate).startOf('day'),
      })
    } else if (!endDate && !startDate) {
      this.setState(this.getDefaultState())
    }
  }

  render() {
    const { type, link, title, heatmapRanges } = this.props
    const { to, from } = this.state

    return (
      <div style={styles.container}>
        <div>
          <h2 style={styles.title}>{title}</h2>
        </div>
        <div style={styles.dateRange}>
          <LogFilter
            to={to}
            from={from}
            maximumNights={28}
            blockFuture
            onNewDates={this.setDates}
          />
        </div>
        <div style={styles.tableWrapper}>
          <DailyTotalTable
            to={to}
            from={from}
            type={type}
            link={link}
            heatmapRanges={heatmapRanges}
          />
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    padding: '24px 24px',
  },
  title: {
    textAlign: 'center',
  },
  dateRange: {
    paddingBottom: 30,
    textAlign: 'center',
  },
  tableWrapper: { overflowY: 'auto', height: '100%' },
}

DailyTotalChart.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
}

export default DailyTotalChart
